import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_portal-category_page_brand_tile-click';
/**
 * an event emitted when a retailer clicks a brand tile on the category page. TileType denotes whether the brand tile is displaying a brand story (&quot;BRAND_STORY&quot;), review (&quot;REVIEW&quot;), or empty (&quot;EMPTY&quot;)
 */
export function trackRetailerPortalCategoryPageBrandTileClick(_tileType) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { _tileType },
    });
}
